import { BaseApi, Environment } from '@nextroll/ar-base-api';
import { RWListRules } from '@nextroll/ar-rollworks-list-builder';

import { IWorkflowSchemaAccountConfig } from 'types/rofl';


const cdpPlusApi = {
    v1: new BaseApi('/zeta/v1/cdp_plus/', {
        environment: (process.env.ENVIRONMENT || 'development') as Environment,
    }),
    v2: new BaseApi('/zeta/v2/cdp_plus/', {
        environment: (process.env.ENVIRONMENT || 'development') as Environment,
    }),
};

const getAccountOrContactList = async (
    advertisableEid: string,
    rules: IWorkflowSchemaAccountConfig,
    isAccount: boolean
) => {
    // account-list uses CDP+ v2 endpoints vs. contact-list still uses v1
    const response = await cdpPlusApi[isAccount ? 'v2' : 'v1'].post(
        `${isAccount ? 'account' : 'contact'}-list/query`,
        { advertisable_eid: advertisableEid },
        rules,
    );
    return response?.result || [];
};

export const getAccountList = (
    advertisableEid: string,
    rules: IWorkflowSchemaAccountConfig
) => getAccountOrContactList(advertisableEid, rules, true);

export const getContactList = (
    advertisableEid: string,
    rules: { list_rule?: RWListRules }
) => getAccountOrContactList(advertisableEid, rules, false);

export default cdpPlusApi;
